module.exports = __webpack_public_path__ + "media/src/images/ogp-79d485d3321605a8c6abf8d0074b8836.jpg";